import React from 'react';
import logoImage from '../../assets/logo_haka.png';
import './Logo.css';

const Logo = ({ className = '' }) => {
  return (
    <div className={`logo-container ${className}`}>
      <img src={logoImage} alt="HAKA" className="logo-image" />
    </div>
  );
};

export default Logo;
